import { useCallback } from "react";
import { POLICIES_POLICY_VALUE_DOWNLOAD } from "../../../constants/policies";
import useCanPerform from "../../../hooks/useCanPerform";
import useDownloadFile from "../../../hooks/useDownloadFile";
import generateApiUri from "../../../libraries/utils/generateApiUri";

/**
 * @typedef {Object} Props
 * @property {import("../../../types/CustomerDocumentPage").CustomerDocumentPage} page
 * @property {(params: {isAllowed: boolean, download: () => void, isLoading: boolean}) => import("react").ReactElement | null} children
 *
 * @param {Props} props
 */
function CustomersDocumentsPagesActionDownload({ page, children }) {
  const { download, isLoading } = useDownloadFile({
    mode: "download",
  });

  const trigger = useCallback(() => {
    download(
      generateApiUri({
        id: "@customers.documents.pages.download",
        parameters: { pageId: page.id },
      }),
    );
  }, [download, page.id]);

  const canPerform = useCanPerform();

  const isAllowed = canPerform({
    policies: POLICIES_POLICY_VALUE_DOWNLOAD,
    resourcePolicies: page.meta?.policies,
  });

  return children({ isAllowed, download: trigger, isLoading });
}

export default CustomersDocumentsPagesActionDownload;
